module.exports = __webpack_public_path__ + "static/SSAFETY1_PIS-8680fd857923499712b5659d011617a8.pdf";